// extracted by mini-css-extract-plugin
module.exports = {"image":"HeroImage_image__w2fXB"};